class NavController {
  constructor($location, auth) {
    this.$location = $location
    this.auth = auth
    this.signInAccordion = false
  }

  get credentials() {
    return this.auth.currentUser
  }

  get loggedIn() {
    return this.auth.loggedIn
  }

  login() {
    this.auth.login()
    this.$location.url('search')
  }

  logout() {
    this.auth.logout()
    this.$location.url('login')
  }

  get path() {
    return this.$location.path()
  }

  toggleSignInAccordion() {
    this.signInAccordion = !this.signInAccordion
  }
}

NavController.$inject = ['$location', 'AuthService']

export default NavController
